export default () => {
  function getCountriesCell() {
    return [{"country":"Afghanistan","code":"93","iso":"AF"},
      {"country":"Albania","code":"355","iso":"AL"},
      {"country":"Algeria","code":"213","iso":"DZ"},
      {"country":"American Samoa","code":"1-684","iso":"AS"},
      {"country":"Andorra","code":"376","iso":"AD"},
      {"country":"Angola","code":"244","iso":"AO"},
      {"country":"Anguilla","code":"1-264","iso":"AI"},
      {"country":"Antarctica","code":"672","iso":"AQ"},
      {"country":"Antigua and Barbuda","code":"1-268","iso":"AG"},
      {"country":"Argentina","code":"54","iso":"AR"},
      {"country":"Armenia","code":"374","iso":"AM"},
      {"country":"Aruba","code":"297","iso":"AW"},
      {"country":"Australia","code":"61","iso":"AU"},
      {"country":"Austria","code":"43","iso":"AT"},
      {"country":"Azerbaijan","code":"994","iso":"AZ"},
      {"country":"Bahamas","code":"1-242","iso":"BS"},
      {"country":"Bahrain","code":"973","iso":"BH"},
      {"country":"Bangladesh","code":"880","iso":"BD"},
      {"country":"Barbados","code":"1-246","iso":"BB"},
      {"country":"Belarus","code":"375","iso":"BY"},
      {"country":"Belgium","code":"32","iso":"BE"},
      {"country":"Belize","code":"501","iso":"BZ"},
      {"country":"Benin","code":"229","iso":"BJ"},
      {"country":"Bermuda","code":"1-441","iso":"BM"},
      {"country":"Bhutan","code":"975","iso":"BT"},
      {"country":"Bolivia","code":"591","iso":"BO"},
      {"country":"Bosnia and Herzegovina","code":"387","iso":"BA"},
      {"country":"Botswana","code":"267","iso":"BW"},
      {"country":"Brazil","code":"55","iso":"BR"},
      {"country":"British Indian Ocean Territory","code":"246","iso":"IO"},
      {"country":"British Virgin Islands","code":"1-284","iso":"VG"},
      {"country":"Brunei","code":"673","iso":"BN"},
      {"country":"Bulgaria","code":"359","iso":"BG"},
      {"country":"Burkina Faso","code":"226","iso":"BF"},
      {"country":"Burundi","code":"257","iso":"BI"},
      {"country":"Cambodia","code":"855","iso":"KH"},
      {"country":"Cameroon","code":"237","iso":"CM"},
      {"country":"Canada","code":"1","iso":"CA"},
      {"country":"Cape Verde","code":"238","iso":"CV"},
      {"country":"Cayman Islands","code":"1-345","iso":"KY"},
      {"country":"Central African Republic","code":"236","iso":"CF"},
      {"country":"Chad","code":"235","iso":"TD"},
      {"country":"Chile","code":"56","iso":"CL"},
      {"country":"China","code":"86","iso":"CN"},
      {"country":"Christmas Island","code":"61","iso":"CX"},
      {"country":"Cocos Islands","code":"61","iso":"CC"},
      {"country":"Colombia","code":"57","iso":"CO"},
      {"country":"Comoros","code":"269","iso":"KM"},
      {"country":"Cook Islands","code":"682","iso":"CK"},
      {"country":"Costa Rica","code":"506","iso":"CR"},
      {"country":"Croatia","code":"385","iso":"HR"},
      {"country":"Cuba","code":"53","iso":"CU"},
      {"country":"Curacao","code":"599","iso":"CW"},
      {"country":"Cyprus","code":"357","iso":"CY"},
      {"country":"Czech Republic","code":"420","iso":"CZ"},
      {"country":"Democratic Republic of the Congo","code":"243","iso":"CD"},
      {"country":"Denmark","code":"45","iso":"DK"},
      {"country":"Djibouti","code":"253","iso":"DJ"},
      {"country":"Dominica","code":"1-767","iso":"DM"},
      {"country":"Dominican Republic","code":"1-809, 1-829, 1-849","iso":"DO"},
      {"country":"East Timor","code":"670","iso":"TL"},
      {"country":"Ecuador","code":"593","iso":"EC"},
      {"country":"Egypt","code":"20","iso":"EG"},
      {"country":"El Salvador","code":"503","iso":"SV"},
      {"country":"Equatorial Guinea","code":"240","iso":"GQ"},
      {"country":"Eritrea","code":"291","iso":"ER"},
      {"country":"Estonia","code":"372","iso":"EE"},
      {"country":"Ethiopia","code":"251","iso":"ET"},
      {"country":"Falkland Islands","code":"500","iso":"FK"},
      {"country":"Faroe Islands","code":"298","iso":"FO"},
      {"country":"Fiji","code":"679","iso":"FJ"},
      {"country":"Finland","code":"358","iso":"FI"},
      {"country":"France","code":"33","iso":"FR"},
      {"country":"French Polynesia","code":"689","iso":"PF"},
      {"country":"Gabon","code":"241","iso":"GA"},
      {"country":"Gambia","code":"220","iso":"GM"},
      {"country":"Georgia","code":"995","iso":"GE"},
      {"country":"Germany","code":"49","iso":"DE"},
      {"country":"Ghana","code":"233","iso":"GH"},
      {"country":"Gibraltar","code":"350","iso":"GI"},
      {"country":"Greece","code":"30","iso":"GR"},
      {"country":"Greenland","code":"299","iso":"GL"},
      {"country":"Grenada","code":"1-473","iso":"GD"},
      {"country":"Guam","code":"1-671","iso":"GU"},
      {"country":"Guatemala","code":"502","iso":"GT"},
      {"country":"Guernsey","code":"44-1481","iso":"GG"},
      {"country":"Guinea","code":"224","iso":"GN"},
      {"country":"Guinea-Bissau","code":"245","iso":"GW"},
      {"country":"Guyana","code":"592","iso":"GY"},
      {"country":"Haiti","code":"509","iso":"HT"},
      {"country":"Honduras","code":"504","iso":"HN"},
      {"country":"Hong Kong","code":"852","iso":"HK"},
      {"country":"Hungary","code":"36","iso":"HU"},
      {"country":"Iceland","code":"354","iso":"IS"},
      {"country":"India","code":"91","iso":"IN"},
      {"country":"Indonesia","code":"62","iso":"ID"},
      {"country":"Iran","code":"98","iso":"IR"},
      {"country":"Iraq","code":"964","iso":"IQ"},
      {"country":"Ireland","code":"353","iso":"IE"},
      {"country":"Isle of Man","code":"44-1624","iso":"IM"},
      {"country":"Israel","code":"972","iso":"IL"},
      {"country":"Italy","code":"39","iso":"IT"},
      {"country":"Ivory Coast","code":"225","iso":"CI"},
      {"country":"Jamaica","code":"1-876","iso":"JM"},
      {"country":"Japan","code":"81","iso":"JP"},
      {"country":"Jersey","code":"44-1534","iso":"JE"},
      {"country":"Jordan","code":"962","iso":"JO"},
      {"country":"Kazakhstan","code":"7","iso":"KZ"},
      {"country":"Kenya","code":"254","iso":"KE"},
      {"country":"Kiribati","code":"686","iso":"KI"},
      {"country":"Kosovo","code":"383","iso":"XK"},
      {"country":"Kuwait","code":"965","iso":"KW"},
      {"country":"Kyrgyzstan","code":"996","iso":"KG"},
      {"country":"Laos","code":"856","iso":"LA"},
      {"country":"Latvia","code":"371","iso":"LV"},
      {"country":"Lebanon","code":"961","iso":"LB"},
      {"country":"Lesotho","code":"266","iso":"LS"},
      {"country":"Liberia","code":"231","iso":"LR"},
      {"country":"Libya","code":"218","iso":"LY"},
      {"country":"Liechtenstein","code":"423","iso":"LI"},
      {"country":"Lithuania","code":"370","iso":"LT"},
      {"country":"Luxembourg","code":"352","iso":"LU"},
      {"country":"Macao","code":"853","iso":"MO"},
      {"country":"Macedonia","code":"389","iso":"MK"},
      {"country":"Madagascar","code":"261","iso":"MG"},
      {"country":"Malawi","code":"265","iso":"MW"},
      {"country":"Malaysia","code":"60","iso":"MY"},
      {"country":"Maldives","code":"960","iso":"MV"},
      {"country":"Mali","code":"223","iso":"ML"},
      {"country":"Malta","code":"356","iso":"MT"},
      {"country":"Marshall Islands","code":"692","iso":"MH"},
      {"country":"Mauritania","code":"222","iso":"MR"},
      {"country":"Mauritius","code":"230","iso":"MU"},
      {"country":"Mayotte","code":"262","iso":"YT"},
      {"country":"Mexico","code":"52","iso":"MX"},
      {"country":"Micronesia","code":"691","iso":"FM"},
      {"country":"Moldova","code":"373","iso":"MD"},
      {"country":"Monaco","code":"377","iso":"MC"},
      {"country":"Mongolia","code":"976","iso":"MN"},
      {"country":"Montenegro","code":"382","iso":"ME"},
      {"country":"Montserrat","code":"1-664","iso":"MS"},
      {"country":"Morocco","code":"212","iso":"MA"},
      {"country":"Mozambique","code":"258","iso":"MZ"},
      {"country":"Myanmar","code":"95","iso":"MM"},
      {"country":"Namibia","code":"264","iso":"NA"},
      {"country":"Nauru","code":"674","iso":"NR"},
      {"country":"Nepal","code":"977","iso":"NP"},
      {"country":"Netherlands","code":"31","iso":"NL"},
      {"country":"Netherlands Antilles","code":"599","iso":"AN"},
      {"country":"New Caledonia","code":"687","iso":"NC"},
      {"country":"New Zealand","code":"64","iso":"NZ"},
      {"country":"Nicaragua","code":"505","iso":"NI"},
      {"country":"Niger","code":"227","iso":"NE"},
      {"country":"Nigeria","code":"234","iso":"NG"},
      {"country":"Niue","code":"683","iso":"NU"},
      {"country":"North Korea","code":"850","iso":"KP"},
      {"country":"Northern Mariana Islands","code":"1-670","iso":"MP"},
      {"country":"Norway","code":"47","iso":"NO"},
      {"country":"Oman","code":"968","iso":"OM"},
      {"country":"Pakistan","code":"92","iso":"PK"},
      {"country":"Palau","code":"680","iso":"PW"},
      {"country":"Palestine","code":"970","iso":"PS"},
      {"country":"Panama","code":"507","iso":"PA"},
      {"country":"Papua New Guinea","code":"675","iso":"PG"},
      {"country":"Paraguay","code":"595","iso":"PY"},
      {"country":"Peru","code":"51","iso":"PE"},
      {"country":"Philippines","code":"63","iso":"PH"},
      {"country":"Pitcairn","code":"64","iso":"PN"},
      {"country":"Poland","code":"48","iso":"PL"},
      {"country":"Portugal","code":"351","iso":"PT"},
      {"country":"Puerto Rico","code":"1-787, 1-939","iso":"PR"},
      {"country":"Qatar","code":"974","iso":"QA"},
      {"country":"Republic of the Congo","code":"242","iso":"CG"},
      {"country":"Reunion","code":"262","iso":"RE"},
      {"country":"Romania","code":"40","iso":"RO"},
      {"country":"Russia","code":"7","iso":"RU"},
      {"country":"Rwanda","code":"250","iso":"RW"},
      {"country":"Saint Barthelemy","code":"590","iso":"BL"},
      {"country":"Saint Helena","code":"290","iso":"SH"},
      {"country":"Saint Kitts and Nevis","code":"1-869","iso":"KN"},
      {"country":"Saint Lucia","code":"1-758","iso":"LC"},
      {"country":"Saint Martin","code":"590","iso":"MF"},
      {"country":"Saint Pierre and Miquelon","code":"508","iso":"PM"},
      {"country":"Saint Vincent and the Grenadines","code":"1-784","iso":"VC"},
      {"country":"Samoa","code":"685","iso":"WS"},
      {"country":"San Marino","code":"378","iso":"SM"},
      {"country":"Sao Tome and Principe","code":"239","iso":"ST"},
      {"country":"Saudi Arabia","code":"966","iso":"SA"},
      {"country":"Senegal","code":"221","iso":"SN"},
      {"country":"Serbia","code":"381","iso":"RS"},
      {"country":"Seychelles","code":"248","iso":"SC"},
      {"country":"Sierra Leone","code":"232","iso":"SL"},
      {"country":"Singapore","code":"65","iso":"SG"},
      {"country":"Sint Maarten","code":"1-721","iso":"SX"},
      {"country":"Slovakia","code":"421","iso":"SK"},
      {"country":"Slovenia","code":"386","iso":"SI"},
      {"country":"Solomon Islands","code":"677","iso":"SB"},
      {"country":"Somalia","code":"252","iso":"SO"},
      {"country":"South Africa","code":"27","iso":"ZA"},
      {"country":"South Korea","code":"82","iso":"KR"},
      {"country":"South Sudan","code":"211","iso":"SS"},
      {"country":"Spain","code":"34","iso":"ES"},
      {"country":"Sri Lanka","code":"94","iso":"LK"},
      {"country":"Sudan","code":"249","iso":"SD"},
      {"country":"Suriname","code":"597","iso":"SR"},
      {"country":"Svalbard and Jan Mayen","code":"47","iso":"SJ"},
      {"country":"Swaziland","code":"268","iso":"SZ"},
      {"country":"Sweden","code":"46","iso":"SE"},
      {"country":"Switzerland","code":"41","iso":"CH"},
      {"country":"Syria","code":"963","iso":"SY"},
      {"country":"Taiwan","code":"886","iso":"TW"},
      {"country":"Tajikistan","code":"992","iso":"TJ"},
      {"country":"Tanzania","code":"255","iso":"TZ"},
      {"country":"Thailand","code":"66","iso":"TH"},
      {"country":"Togo","code":"228","iso":"TG"},
      {"country":"Tokelau","code":"690","iso":"TK"},
      {"country":"Tonga","code":"676","iso":"TO"},
      {"country":"Trinidad and Tobago","code":"1-868","iso":"TT"},
      {"country":"Tunisia","code":"216","iso":"TN"},
      {"country":"Turkey","code":"90","iso":"TR"},
      {"country":"Turkmenistan","code":"993","iso":"TM"},
      {"country":"Turks and Caicos Islands","code":"1-649","iso":"TC"},
      {"country":"Tuvalu","code":"688","iso":"TV"},
      {"country":"U.S. Virgin Islands","code":"1-340","iso":"VI"},
      {"country":"Uganda","code":"256","iso":"UG"},
      {"country":"Ukraine","code":"380","iso":"UA"},
      {"country":"United Arab Emirates","code":"971","iso":"AE"},
      {"country":"United Kingdom","code":"44","iso":"GB"},
      {"country":"United States","code":"1","iso":"US"},
      {"country":"Uruguay","code":"598","iso":"UY"},
      {"country":"Uzbekistan","code":"998","iso":"UZ"},
      {"country":"Vanuatu","code":"678","iso":"VU"},
      {"country":"Vatican","code":"379","iso":"VA"},
      {"country":"Venezuela","code":"58","iso":"VE"},
      {"country":"Vietnam","code":"84","iso":"VN"},
      {"country":"Wallis and Futuna","code":"681","iso":"WF"},
      {"country":"Western Sahara","code":"212","iso":"EH"},
      {"country":"Yemen","code":"967","iso":"YE"},
      {"country":"Zambia","code":"260","iso":"ZM"},
      {"country":"Zimbabwe","code":"263","iso":"ZW"}]
  }
  function getPtCountriesCell() {
    return [
      {"country":"Afeganistão","code":"93","iso":"AF"},
      {"country":"Albânia","code":"355","iso":"AL"},
      {"country":"Argélia","code":"213","iso":"DZ"},
      {"country":"Samoa Americana","code":"1-684","iso":"AS"},
      {"country":"Andorra","code":"376","iso":"AD"},
      {"country":"Angola","code":"244","iso":"AO"},
      {"country":"Anguilla","code":"1-264","iso":"AI"},
      {"country":"Antártica","code":"672","iso":"AQ"},
      {"country":"Antígua e Barbuda","code":"1-268","iso":"AG"},
      {"country":"Argentina","code":"54","iso":"AR"},
      {"country":"Armênia","code":"374","iso":"AM"},
      {"country":"Aruba","code":"297","iso":"AW"},
      {"country":"Austrália","code":"61","iso":"AU"},
      {"country":"Áustria","code":"43","iso":"AT"},
      {"country":"Azerbaijão","code":"994","iso":"AZ"},
      {"country":"Bahamas","code":"1-242","iso":"BS"},
      {"country":"Bahrein","code":"973","iso":"BH"},
      {"country":"Bangladesh","code":"880","iso":"BD"},
      {"country":"Barbados","code":"1-246","iso":"BB"},
      {"country":"Bielorrússia","code":"375","iso":"BY"},
      {"country":"Bélgica","code":"32","iso":"BE"},
      {"country":"Belize","code":"501","iso":"BZ"},
      {"country":"Benin","code":"229","iso":"BJ"},
      {"country":"Bermudas","code":"1-441","iso":"BM"},
      {"country":"Butão","code":"975","iso":"BT"},
      {"country":"Bolívia","code":"591","iso":"BO"},
      {"country":"Bósnia e Herzegovina","code":"387","iso":"BA"},
      {"country":"Botsuana","code":"267","iso":"BW"},
      {"country":"Brasil","code":"55","iso":"BR"},
      {"country":"Território Britânico do Oceano Índico","code":"246","iso":"IO"},
      {"country":"Ilhas Virgens Britânicas","code":"1-284","iso":"VG"},
      {"country":"Brunei","code":"673","iso":"BN"},
      {"country":"Bulgária","code":"359","iso":"BG"},
      {"country":"Burkina Faso","code":"226","iso":"BF"},
      {"country":"Burundi","code":"257","iso":"BI"},
      {"country":"Camboja","code":"855","iso":"KH"},
      {"country":"Camarões","code":"237","iso":"CM"},
      {"country":"Canadá","code":"1","iso":"CA"},
      {"country":"Cabo Verde","code":"238","iso":"CV"},
      {"country":"Ilhas Cayman","code":"1-345","iso":"KY"},
      {"country":"República Centro-Africana","code":"236","iso":"CF"},
      {"country":"Chade","code":"235","iso":"TD"},
      {"country":"Chile","code":"56","iso":"CL"},
      {"country":"China","code":"86","iso":"CN"},
      {"country":"Ilha Christmas","code":"61","iso":"CX"},
      {"country":"Ilhas Cocos","code":"61","iso":"CC"},
      {"country":"Colômbia","code":"57","iso":"CO"},
      {"country":"Comores","code":"269","iso":"KM"},
      {"country":"Ilhas Cook","code":"682","iso":"CK"},
      {"country":"Costa Rica","code":"506","iso":"CR"},
      {"country":"Croácia","code":"385","iso":"HR"},
      {"country":"Cuba","code":"53","iso":"CU"},
      {"country":"Curaçao","code":"599","iso":"CW"},
      {"country":"Chipre","code":"357","iso":"CY"},
      {"country":"República Tcheca","code":"420","iso":"CZ"},
      {"country":"República Democrática do Congo","code":"243","iso":"CD"},
      {"country":"Dinamarca","code":"45","iso":"DK"},
      {"country":"Djibuti","code":"253","iso":"DJ"},
      {"country":"Dominica","code":"1-767","iso":"DM"},
      {"country":"República Dominicana","code":"1-809, 1-829, 1-849","iso":"DO"},
      {"country":"Timor-Leste","code":"670","iso":"TL"},
      {"country":"Equador","code":"593","iso":"EC"},
      {"country":"Egito","code":"20","iso":"EG"},
      {"country":"El Salvador","code":"503","iso":"SV"},
      {"country":"Guiné Equatorial","code":"240","iso":"GQ"},
      {"country":"Eritreia","code":"291","iso":"ER"},
      {"country":"Estônia","code":"372","iso":"EE"},
      {"country":"Etiópia","code":"251","iso":"ET"},
      {"country":"Ilhas Malvinas","code":"500","iso":"FK"},
      {"country":"Ilhas Faroe","code":"298","iso":"FO"},
      {"country":"Fiji","code":"679","iso":"FJ"},
      {"country":"Finlândia","code":"358","iso":"FI"},
      {"country":"França","code":"33","iso":"FR"},
      {"country":"Polinésia Francesa","code":"689","iso":"PF"},
      {"country":"Gabão","code":"241","iso":"GA"},
      {"country":"Gâmbia","code":"220","iso":"GM"},
      {"country":"Geórgia","code":"995","iso":"GE"},
      {"country":"Alemanha","code":"49","iso":"DE"},
      {"country":"Gana","code":"233","iso":"GH"},
      {"country":"Gibraltar","code":"350","iso":"GI"},
      {"country":"Grécia","code":"30","iso":"GR"},
      {"country":"Groenlândia","code":"299","iso":"GL"},
      {"country":"Granada","code":"1-473","iso":"GD"},
      {"country":"Guam","code":"1-671","iso":"GU"},
      {"country":"Guatemala","code":"502","iso":"GT"},
      {"country":"Guernsey","code":"44-1481","iso":"GG"},
      {"country":"Guiné","code":"224","iso":"GN"},
      {"country":"Guiné-Bissau","code":"245","iso":"GW"},
      {"country":"Guiana","code":"592","iso":"GY"},
      {"country":"Haiti","code":"509","iso":"HT"},
      {"country":"Honduras","code":"504","iso":"HN"},
      {"country":"Hong Kong","code":"852","iso":"HK"},
      {"country":"Hungria","code":"36","iso":"HU"},
      {"country":"Islândia","code":"354","iso":"IS"},
      {"country":"Índia","code":"91","iso":"IN"},
      {"country":"Indonésia","code":"62","iso":"ID"},
      {"country":"Irã","code":"98","iso":"IR"},
      {"country":"Iraque","code":"964","iso":"IQ"},
      {"country":"Irlanda","code":"353","iso":"IE"},
      {"country":"Ilha de Man","code":"44-1624","iso":"IM"},
      {"country":"Israel","code":"972","iso":"IL"},
      {"country":"Itália","code":"39","iso":"IT"},
      {"country":"Costa do Marfim","code":"225","iso":"CI"},
      {"country":"Jamaica","code":"1-876","iso":"JM"},
      {"country":"Japão","code":"81","iso":"JP"},
      {"country":"Jersey","code":"44-1534","iso":"JE"},
      {"country":"Jordânia","code":"962","iso":"JO"},
      {"country":"Cazaquistão","code":"7","iso":"KZ"},
      {"country":"Quênia","code":"254","iso":"KE"},
      {"country":"Kiribati","code":"686","iso":"KI"},
      {"country":"Kosovo","code":"383","iso":"XK"},
      {"country":"Kuwait","code":"965","iso":"KW"},
      {"country":"Quirguistão","code":"996","iso":"KG"},
      {"country":"Laos","code":"856","iso":"LA"},
      {"country":"Letônia","code":"371","iso":"LV"},
      {"country":"Líbano","code":"961","iso":"LB"},
      {"country":"Lesoto","code":"266","iso":"LS"},
      {"country":"Libéria","code":"231","iso":"LR"},
      {"country":"Líbia","code":"218","iso":"LY"},
      {"country":"Liechtenstein","code":"423","iso":"LI"},
      {"country":"Lituânia","code":"370","iso":"LT"},
      {"country":"Luxemburgo","code":"352","iso":"LU"},
      {"country":"Macau","code":"853","iso":"MO"},
      {"country":"Macedônia","code":"389","iso":"MK"},
      {"country":"Madagascar","code":"261","iso":"MG"},
      {"country":"Malaui","code":"265","iso":"MW"},
      {"country":"Malásia","code":"60","iso":"MY"},
      {"country":"Maldivas","code":"960","iso":"MV"},
      {"country":"Mali","code":"223","iso":"ML"},
      {"country":"Malta","code":"356","iso":"MT"},
      {"country":"Ilhas Marshall","code":"692","iso":"MH"},
      {"country":"Mauritânia","code":"222","iso":"MR"},
      {"country":"Maurício","code":"230","iso":"MU"},
      {"country":"Mayotte","code":"262","iso":"YT"},
      {"country":"México","code":"52","iso":"MX"},
      {"country":"Micronésia","code":"691","iso":"FM"},
      {"country":"Moldávia","code":"373","iso":"MD"},
      {"country":"Mônaco","code":"377","iso":"MC"},
      {"country":"Mongólia","code":"976","iso":"MN"},
      {"country":"Montenegro","code":"382","iso":"ME"},
      {"country":"Montserrat","code":"1-664","iso":"MS"},
      {"country":"Marrocos","code":"212","iso":"MA"},
      {"country":"Moçambique","code":"258","iso":"MZ"},
      {"country":"Mianmar","code":"95","iso":"MM"},
      {"country":"Namíbia","code":"264","iso":"NA"},
      {"country":"Nauru","code":"674","iso":"NR"},
      {"country":"Nepal","code":"977","iso":"NP"},
      {"country":"Holanda","code":"31","iso":"NL"},
      {"country":"Antilhas Holandesas","code":"599","iso":"AN"},
      {"country":"Nova Caledônia","code":"687","iso":"NC"},
      {"country":"Nova Zelândia","code":"64","iso":"NZ"},
      {"country":"Nicarágua","code":"505","iso":"NI"},
      {"country":"Níger","code":"227","iso":"NE"},
      {"country":"Nigéria","code":"234","iso":"NG"},
      {"country":"Niue","code":"683","iso":"NU"},
      {"country":"Coreia do Norte","code":"850","iso":"KP"},
      {"country":"Ilhas Marianas do Norte","code":"1-670","iso":"MP"},
      {"country":"Noruega","code":"47","iso":"NO"},
      {"country":"Omã","code":"968","iso":"OM"},
      {"country":"Paquistão","code":"92","iso":"PK"},
      {"country":"Palau","code":"680","iso":"PW"},
      {"country":"Palestina","code":"970","iso":"PS"},
      {"country":"Panamá","code":"507","iso":"PA"},
      {"country":"Papua-Nova Guiné","code":"675","iso":"PG"},
      {"country":"Paraguai","code":"595","iso":"PY"},
      {"country":"Peru","code":"51","iso":"PE"},
      {"country":"Filipinas","code":"63","iso":"PH"},
      {"country":"Pitcairn","code":"64","iso":"PN"},
      {"country":"Polônia","code":"48","iso":"PL"},
      {"country":"Portugal","code":"351","iso":"PT"},
      {"country":"Porto Rico","code":"1-787, 1-939","iso":"PR"},
      {"country":"Catar","code":"974","iso":"QA"},
      {"country":"República do Congo","code":"242","iso":"CG"},
      {"country":"Reunião","code":"262","iso":"RE"},
      {"country":"Romênia","code":"40","iso":"RO"},
      {"country":"Rússia","code":"7","iso":"RU"},
      {"country":"Ruanda","code":"250","iso":"RW"},
      {"country":"Saint-Barthélemy","code":"590","iso":"BL"},
      {"country":"Santa Helena","code":"290","iso":"SH"},
      {"country":"Saint Kitts e Nevis","code":"1-869","iso":"KN"},
      {"country":"Santa Lúcia","code":"1-758","iso":"LC"},
      {"country":"Saint Martin","code":"590","iso":"MF"},
      {"country":"Saint-Pierre e Miquelon","code":"508","iso":"PM"},
      {"country":"São Vicente e Granadinas","code":"1-784","iso":"VC"},
      {"country":"Samoa","code":"685","iso":"WS"},
      {"country":"San Marino","code":"378","iso":"SM"},
      {"country":"São Tomé e Príncipe","code":"239","iso":"ST"},
      {"country":"Arábia Saudita","code":"966","iso":"SA"},
      {"country":"Senegal","code":"221","iso":"SN"},
      {"country":"Sérvia","code":"381","iso":"RS"},
      {"country":"Seychelles","code":"248","iso":"SC"},
      {"country":"Serra Leoa","code":"232","iso":"SL"},
      {"country":"Singapura","code":"65","iso":"SG"},
      {"country":"Sint Maarten","code":"1-721","iso":"SX"},
      {"country":"Eslováquia","code":"421","iso":"SK"},
      {"country":"Eslovênia","code":"386","iso":"SI"},
      {"country":"Ilhas Salomão","code":"677","iso":"SB"},
      {"country":"Somália","code":"252","iso":"SO"},
      {"country":"África do Sul","code":"27","iso":"ZA"},
      {"country":"Coreia do Sul","code":"82","iso":"KR"},
      {"country":"Sudão do Sul","code":"211","iso":"SS"},
      {"country":"Espanha","code":"34","iso":"ES"},
      {"country":"Sri Lanka","code":"94","iso":"LK"},
      {"country":"Sudão","code":"249","iso":"SD"},
      {"country":"Suriname","code":"597","iso":"SR"},
      {"country":"Svalbard e Jan Mayen","code":"47","iso":"SJ"},
      {"country":"Suazilândia","code":"268","iso":"SZ"},
      {"country":"Suécia","code":"46","iso":"SE"},
      {"country":"Suíça","code":"41","iso":"CH"},
      {"country":"Síria","code":"963","iso":"SY"},
      {"country":"Taiwan","code":"886","iso":"TW"},
      {"country":"Tajiquistão","code":"992","iso":"TJ"},
      {"country":"Tanzânia","code":"255","iso":"TZ"},
      {"country":"Tailândia","code":"66","iso":"TH"},
      {"country":"Togo","code":"228","iso":"TG"},
      {"country":"Tokelau","code":"690","iso":"TK"},
      {"country":"Tonga","code":"676","iso":"TO"},
      {"country":"Trinidad e Tobago","code":"1-868","iso":"TT"},
      {"country":"Tunísia","code":"216","iso":"TN"},
      {"country":"Turquia","code":"90","iso":"TR"},
      {"country":"Turcomenistão","code":"993","iso":"TM"},
      {"country":"Ilhas Turks e Caicos","code":"1-649","iso":"TC"},
      {"country":"Tuvalu","code":"688","iso":"TV"},
      {"country":"Ilhas Virgens dos EUA","code":"1-340","iso":"VI"},
      {"country":"Uganda","code":"256","iso":"UG"},
      {"country":"Ucrânia","code":"380","iso":"UA"},
      {"country":"Emirados Árabes Unidos","code":"971","iso":"AE"},
      {"country":"Reino Unido","code":"44","iso":"GB"},
      {"country":"Estados Unidos","code":"1","iso":"US"},
      {"country":"Uruguai","code":"598","iso":"UY"},
      {"country":"Uzbequistão","code":"998","iso":"UZ"},
      {"country":"Vanuatu","code":"678","iso":"VU"},
      {"country":"Vaticano","code":"379","iso":"VA"},
      {"country":"Venezuela","code":"58","iso":"VE"},
      {"country":"Vietnã","code":"84","iso":"VN"},
      {"country":"Wallis e Futuna","code":"681","iso":"WF"},
      {"country":"Saara Ocidental","code":"212","iso":"EH"},
      {"country":"Iêmen","code":"967","iso":"YE"},
      {"country":"Zâmbia","code":"260","iso":"ZM"},
      {"country":"Zimbábue","code":"263","iso":"ZW"}
    ];
  }
  function getEsCountriesCell() {
    return [
      {"country":"Afganistán","code":"93","iso":"AF"},
      {"country":"Albania","code":"355","iso":"AL"},
      {"country":"Argelia","code":"213","iso":"DZ"},
      {"country":"Samoa Americana","code":"1-684","iso":"AS"},
      {"country":"Andorra","code":"376","iso":"AD"},
      {"country":"Angola","code":"244","iso":"AO"},
      {"country":"Anguila","code":"1-264","iso":"AI"},
      {"country":"Antártida","code":"672","iso":"AQ"},
      {"country":"Antigua y Barbuda","code":"1-268","iso":"AG"},
      {"country":"Argentina","code":"54","iso":"AR"},
      {"country":"Armenia","code":"374","iso":"AM"},
      {"country":"Aruba","code":"297","iso":"AW"},
      {"country":"Australia","code":"61","iso":"AU"},
      {"country":"Austria","code":"43","iso":"AT"},
      {"country":"Azerbaiyán","code":"994","iso":"AZ"},
      {"country":"Bahamas","code":"1-242","iso":"BS"},
      {"country":"Baréin","code":"973","iso":"BH"},
      {"country":"Bangladesh","code":"880","iso":"BD"},
      {"country":"Barbados","code":"1-246","iso":"BB"},
      {"country":"Bielorrusia","code":"375","iso":"BY"},
      {"country":"Bélgica","code":"32","iso":"BE"},
      {"country":"Belice","code":"501","iso":"BZ"},
      {"country":"Benin","code":"229","iso":"BJ"},
      {"country":"Bermudas","code":"1-441","iso":"BM"},
      {"country":"Bután","code":"975","iso":"BT"},
      {"country":"Bolivia","code":"591","iso":"BO"},
      {"country":"Bosnia y Herzegovina","code":"387","iso":"BA"},
      {"country":"Botswana","code":"267","iso":"BW"},
      {"country":"Brasil","code":"55","iso":"BR"},
      {"country":"Territorio Británico del Océano Índico","code":"246","iso":"IO"},
      {"country":"Islas Vírgenes Británicas","code":"1-284","iso":"VG"},
      {"country":"Brunéi","code":"673","iso":"BN"},
      {"country":"Bulgaria","code":"359","iso":"BG"},
      {"country":"Burkina Faso","code":"226","iso":"BF"},
      {"country":"Burundi","code":"257","iso":"BI"},
      {"country":"Camboya","code":"855","iso":"KH"},
      {"country":"Camerún","code":"237","iso":"CM"},
      {"country":"Canadá","code":"1","iso":"CA"},
      {"country":"Cabo Verde","code":"238","iso":"CV"},
      {"country":"Islas Caimán","code":"1-345","iso":"KY"},
      {"country":"República Centroafricana","code":"236","iso":"CF"},
      {"country":"Chad","code":"235","iso":"TD"},
      {"country":"Chile","code":"56","iso":"CL"},
      {"country":"China","code":"86","iso":"CN"},
      {"country":"Isla de Navidad","code":"61","iso":"CX"},
      {"country":"Islas Cocos","code":"61","iso":"CC"},
      {"country":"Colombia","code":"57","iso":"CO"},
      {"country":"Comoras","code":"269","iso":"KM"},
      {"country":"Islas Cook","code":"682","iso":"CK"},
      {"country":"Costa Rica","code":"506","iso":"CR"},
      {"country":"Croacia","code":"385","iso":"HR"},
      {"country":"Cuba","code":"53","iso":"CU"},
      {"country":"Curazao","code":"599","iso":"CW"},
      {"country":"Chipre","code":"357","iso":"CY"},
      {"country":"República Checa","code":"420","iso":"CZ"},
      {"country":"República Democrática del Congo","code":"243","iso":"CD"},
      {"country":"Dinamarca","code":"45","iso":"DK"},
      {"country":"Djibouti","code":"253","iso":"DJ"},
      {"country":"Dominica","code":"1-767","iso":"DM"},
      {"country":"República Dominicana","code":"1-809, 1-829, 1-849","iso":"DO"},
      {"country":"Timor Oriental","code":"670","iso":"TL"},
      {"country":"Ecuador","code":"593","iso":"EC"},
      {"country":"Egipto","code":"20","iso":"EG"},
      {"country":"El Salvador","code":"503","iso":"SV"},
      {"country":"Guinea Ecuatorial","code":"240","iso":"GQ"},
      {"country":"Eritrea","code":"291","iso":"ER"},
      {"country":"Estonia","code":"372","iso":"EE"},
      {"country":"Etiopía","code":"251","iso":"ET"},
      {"country":"Islas Malvinas","code":"500","iso":"FK"},
      {"country":"Islas Feroe","code":"298","iso":"FO"},
      {"country":"Fiyi","code":"679","iso":"FJ"},
      {"country":"Finlandia","code":"358","iso":"FI"},
      {"country":"Francia","code":"33","iso":"FR"},
      {"country":"Polinesia Francesa","code":"689","iso":"PF"},
      {"country":"Gabón","code":"241","iso":"GA"},
      {"country":"Gambia","code":"220","iso":"GM"},
      {"country":"Georgia","code":"995","iso":"GE"},
      {"country":"Alemania","code":"49","iso":"DE"},
      {"country":"Ghana","code":"233","iso":"GH"},
      {"country":"Gibraltar","code":"350","iso":"GI"},
      {"country":"Grecia","code":"30","iso":"GR"},
      {"country":"Groenlandia","code":"299","iso":"GL"},
      {"country":"Granada","code":"1-473","iso":"GD"},
      {"country":"Guam","code":"1-671","iso":"GU"},
      {"country":"Guatemala","code":"502","iso":"GT"},
      {"country":"Guernsey","code":"44-1481","iso":"GG"},
      {"country":"Guinea","code":"224","iso":"GN"},
      {"country":"Guinea-Bissau","code":"245","iso":"GW"},
      {"country":"Guyana","code":"592","iso":"GY"},
      {"country":"Haití","code":"509","iso":"HT"},
      {"country":"Honduras","code":"504","iso":"HN"},
      {"country":"Hong Kong","code":"852","iso":"HK"},
      {"country":"Hungría","code":"36","iso":"HU"},
      {"country":"Islandia","code":"354","iso":"IS"},
      {"country":"India","code":"91","iso":"IN"},
      {"country":"Indonesia","code":"62","iso":"ID"},
      {"country":"Irán","code":"98","iso":"IR"},
      {"country":"Iraq","code":"964","iso":"IQ"},
      {"country":"Irlanda","code":"353","iso":"IE"},
      {"country":"Isla de Man","code":"44-1624","iso":"IM"},
      {"country":"Israel","code":"972","iso":"IL"},
      {"country":"Italia","code":"39","iso":"IT"},
      {"country":"Costa de Marfil","code":"225","iso":"CI"},
      {"country":"Jamaica","code":"1-876","iso":"JM"},
      {"country":"Japón","code":"81","iso":"JP"},
      {"country":"Jersey","code":"44-1534","iso":"JE"},
      {"country":"Jordania","code":"962","iso":"JO"},
      {"country":"Kazajistán","code":"7","iso":"KZ"},
      {"country":"Kenia","code":"254","iso":"KE"},
      {"country":"Kiribati","code":"686","iso":"KI"},
      {"country":"Kosovo","code":"383","iso":"XK"},
      {"country":"Kuwait","code":"965","iso":"KW"},
      {"country":"Kirguistán","code":"996","iso":"KG"},
      {"country":"Laos","code":"856","iso":"LA"},
      {"country":"Letonia","code":"371","iso":"LV"},
      {"country":"Líbano","code":"961","iso":"LB"},
      {"country":"Lesoto","code":"266","iso":"LS"},
      {"country":"Liberia","code":"231","iso":"LR"},
      {"country":"Libia","code":"218","iso":"LY"},
      {"country":"Liechtenstein","code":"423","iso":"LI"},
      {"country":"Lituania","code":"370","iso":"LT"},
      {"country":"Luxemburgo","code":"352","iso":"LU"},
      {"country":"Macao","code":"853","iso":"MO"},
      {"country":"Macedonia del Norte","code":"389","iso":"MK"},
      {"country":"Madagascar","code":"261","iso":"MG"},
      {"country":"Malawi","code":"265","iso":"MW"},
      {"country":"Malasia","code":"60","iso":"MY"},
      {"country":"Maldivas","code":"960","iso":"MV"},
      {"country":"Malí","code":"223","iso":"ML"},
      {"country":"Malta","code":"356","iso":"MT"},
      {"country":"Islas Marshall","code":"692","iso":"MH"},
      {"country":"Mauritania","code":"222","iso":"MR"},
      {"country":"Mauricio","code":"230","iso":"MU"},
      {"country":"Mayotte","code":"262","iso":"YT"},
      {"country":"México","code":"52","iso":"MX"},
      {"country":"Micronesia","code":"691","iso":"FM"},
      {"country":"Moldavia","code":"373","iso":"MD"},
      {"country":"Mónaco","code":"377","iso":"MC"},
      {"country":"Mongolia","code":"976","iso":"MN"},
      {"country":"Montenegro","code":"382","iso":"ME"},
      {"country":"Montserrat","code":"1-664","iso":"MS"},
      {"country":"Marruecos","code":"212","iso":"MA"},
      {"country":"Mozambique","code":"258","iso":"MZ"},
      {"country":"Myanmar","code":"95","iso":"MM"},
      {"country":"Namibia","code":"264","iso":"NA"},
      {"country":"Nauru","code":"674","iso":"NR"},
      {"country":"Nepal","code":"977","iso":"NP"},
      {"country":"Países Bajos","code":"31","iso":"NL"},
      {"country":"Antillas Neerlandesas","code":"599","iso":"AN"},
      {"country":"Nueva Caledonia","code":"687","iso":"NC"},
      {"country":"Nueva Zelanda","code":"64","iso":"NZ"},
      {"country":"Nicaragua","code":"505","iso":"NI"},
      {"country":"Níger","code":"227","iso":"NE"},
      {"country":"Nigeria","code":"234","iso":"NG"},
      {"country":"Niue","code":"683","iso":"NU"},
      {"country":"Corea del Norte","code":"850","iso":"KP"},
      {"country":"Islas Marianas del Norte","code":"1-670","iso":"MP"},
      {"country":"Noruega","code":"47","iso":"NO"},
      {"country":"Omán","code":"968","iso":"OM"},
      {"country":"Pakistán","code":"92","iso":"PK"},
      {"country":"Palau","code":"680","iso":"PW"},
      {"country":"Palestina","code":"970","iso":"PS"},
      {"country":"Panamá","code":"507","iso":"PA"},
      {"country":"Papúa Nueva Guinea","code":"675","iso":"PG"},
      {"country":"Paraguay","code":"595","iso":"PY"},
      {"country":"Perú","code":"51","iso":"PE"},
      {"country":"Filipinas","code":"63","iso":"PH"},
      {"country":"Pitcairn","code":"64","iso":"PN"},
      {"country":"Polonia","code":"48","iso":"PL"},
      {"country":"Portugal","code":"351","iso":"PT"},
      {"country":"Puerto Rico","code":"1-787, 1-939","iso":"PR"},
      {"country":"Catar","code":"974","iso":"QA"},
      {"country":"República del Congo","code":"242","iso":"CG"},
      {"country":"Reunión","code":"262","iso":"RE"},
      {"country":"Rumania","code":"40","iso":"RO"},
      {"country":"Rusia","code":"7","iso":"RU"},
      {"country":"Ruanda","code":"250","iso":"RW"},
      {"country":"San Bartolomé","code":"590","iso":"BL"},
      {"country":"Santa Elena","code":"290","iso":"SH"},
      {"country":"San Cristóbal y Nieves","code":"1-869","iso":"KN"},
      {"country":"Santa Lucía","code":"1-758","iso":"LC"},
      {"country":"San Martín","code":"590","iso":"MF"},
      {"country":"San Pedro y Miquelón","code":"508","iso":"PM"},
      {"country":"San Vicente y las Granadinas","code":"1-784","iso":"VC"},
      {"country":"Samoa","code":"685","iso":"WS"},
      {"country":"San Marino","code":"378","iso":"SM"},
      {"country":"Santo Tomé y Príncipe","code":"239","iso":"ST"},
      {"country":"Arabia Saudita","code":"966","iso":"SA"},
      {"country":"Senegal","code":"221","iso":"SN"},
      {"country":"Serbia","code":"381","iso":"RS"},
      {"country":"Seychelles","code":"248","iso":"SC"},
      {"country":"Sierra Leona","code":"232","iso":"SL"},
      {"country":"Singapur","code":"65","iso":"SG"},
      {"country":"Sint Maarten","code":"1-721","iso":"SX"},
      {"country":"Eslovaquia","code":"421","iso":"SK"},
      {"country":"Eslovenia","code":"386","iso":"SI"},
      {"country":"Islas Salomón","code":"677","iso":"SB"},
      {"country":"Somalia","code":"252","iso":"SO"},
      {"country":"Sudáfrica","code":"27","iso":"ZA"},
      {"country":"Corea del Sur","code":"82","iso":"KR"},
      {"country":"Sudán del Sur","code":"211","iso":"SS"},
      {"country":"España","code":"34","iso":"ES"},
      {"country":"Sri Lanka","code":"94","iso":"LK"},
      {"country":"Sudán","code":"249","iso":"SD"},
      {"country":"Surinam","code":"597","iso":"SR"},
      {"country":"Svalbard y Jan Mayen","code":"47","iso":"SJ"},
      {"country":"Suazilandia","code":"268","iso":"SZ"},
      {"country":"Suecia","code":"46","iso":"SE"},
      {"country":"Suiza","code":"41","iso":"CH"},
      {"country":"Siria","code":"963","iso":"SY"},
      {"country":"Taiwán","code":"886","iso":"TW"},
      {"country":"Tayikistán","code":"992","iso":"TJ"},
      {"country":"Tanzania","code":"255","iso":"TZ"},
      {"country":"Tailandia","code":"66","iso":"TH"},
      {"country":"Togo","code":"228","iso":"TG"},
      {"country":"Tokelau","code":"690","iso":"TK"},
      {"country":"Tonga","code":"676","iso":"TO"},
      {"country":"Trinidad y Tobago","code":"1-868","iso":"TT"},
      {"country":"Túnez","code":"216","iso":"TN"},
      {"country":"Turquía","code":"90","iso":"TR"},
      {"country":"Turkmenistán","code":"993","iso":"TM"},
      {"country":"Islas Turcas y Caicos","code":"1-649","iso":"TC"},
      {"country":"Tuvalu","code":"688","iso":"TV"},
      {"country":"Islas Vírgenes de los Estados Unidos","code":"1-340","iso":"VI"},
      {"country":"Uganda","code":"256","iso":"UG"},
      {"country":"Ucrania","code":"380","iso":"UA"},
      {"country":"Emiratos Árabes Unidos","code":"971","iso":"AE"},
      {"country":"Reino Unido","code":"44","iso":"GB"},
      {"country":"Estados Unidos","code":"1","iso":"US"},
      {"country":"Uruguay","code":"598","iso":"UY"},
      {"country":"Uzbekistán","code":"998","iso":"UZ"},
      {"country":"Vanuatu","code":"678","iso":"VU"},
      {"country":"Ciudad del Vaticano","code":"379","iso":"VA"},
      {"country":"Venezuela","code":"58","iso":"VE"},
      {"country":"Vietnam","code":"84","iso":"VN"},
      {"country":"Wallis y Futuna","code":"681","iso":"WF"},
      {"country":"Sahara Occidental","code":"212","iso":"EH"},
      {"country":"Yemen","code":"967","iso":"YE"},
      {"country":"Zambia","code":"260","iso":"ZM"},
      {"country":"Zimbabwe","code":"263","iso":"ZW"},
      {"country":"Islas Åland","code":"358","iso":"AX"}
    ];
  }
  return { getCountriesCell,  getPtCountriesCell, getEsCountriesCell }
}
